import { ReactElement } from 'react';
import { toast } from '@/components/core/Toast';
import { ExternalToast } from 'sonner';

type ToastAction = {
    btnText: string,
    func: () => any,
}

export type ToastVariant = 'normal' | 'success' | 'error';

export type ToastNotification = {
    title: ReactElement | string,
    description: ReactElement | string,
    button: string,
    primaryAction: ToastAction,
    secondaryAction: ToastAction,
    handleClose?: () => any,
    variant?: ToastVariant,
    withDescriptionAlignment?: boolean
}

export type ToastNotificationSonner = ToastNotification & {sonner: ExternalToast}

export default function useToast() {
    return [toast];
}
